import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-423">
      <div className="max-w-4xl mx-auto text-center" data-id="element-424">
        {/* Logo */}
        <div className="mb-2" data-id="element-425">
          <span className="text-white text-3xl sm:text-5xl font-black tracking-tight" data-id="element-426">
            🥊 PROFEPACK™
          </span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-[#F97316] mb-4" data-id="element-427">
          MEGAPACK BOXEO LISTO
        </h2>
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-6 leading-snug" data-id="element-428">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </h3>
        <p className="text-white text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-429">
          300+ páginas · 140 clases modelo · Round-by-Round · Técnica · Potencia
          · Defensa · Táctica · Sparring · Gestión · Comunicación. Funciona
          desde mañana.
        </p>

        {/* Mockup visual — 6 books in a row */}
        <div className="relative mx-auto mb-10 max-w-md sm:max-w-2xl" data-id="element-430">
          <div className="grid grid-cols-6 gap-2 sm:gap-3 justify-center" data-id="element-431">
            {[{
            color: '#1565C0',
            label: 'Principiante'
          }, {
            color: '#2E7D32',
            label: 'Intermedio'
          }, {
            color: '#E65100',
            label: 'Avanzado'
          }, {
            color: '#6A1B9A',
            label: 'Técnica'
          }, {
            color: '#37474F',
            label: 'Defensa'
          }, {
            color: '#BF360C',
            label: 'Gestión'
          }].map((item, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: item.color,
            border: '2px solid #F97316'
          }} data-id="element-432">
                <span className="text-white text-[10px] sm:text-xs font-bold px-1 text-center" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-433">
                  {item.label}
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#F97316] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-434">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-col items-center gap-3 mt-8 w-full max-w-lg mx-auto" data-id="element-435">
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-436">
            ✅ Por nivel y progresión bimestral
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-437">
            ✅ 140 clases completas Round-by-Round
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-438">
            ✅ Evaluaciones + seguimiento individual
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-5 py-3 rounded-full w-full text-center" data-id="element-439">
            ✅ Técnica + Potencia + Defensa + Táctica + Sparring
          </span>
        </div>
      </div>
    </section>;
}